const WorkspacesSettingsTab = {
    ISSUETYPE: 0,
    LOGO: 1,
    ACCESS: 2,
}

export default WorkspacesSettingsTab;
